import Cookies from 'js-cookie';

const isProd = window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1';

const COOKIE_CONFIG = {
  ...(isProd && { domain: "meterpromax.com", secure: true }),
  sameSite: "Lax",
};

export const getCookie = (key) => Cookies.get(key);

export const setCookie = (key, value, options = {}) =>
  Cookies.set(key, value, { ...COOKIE_CONFIG, expires:1,  ...options });

export const removeCookie = (key) =>
  Cookies.remove(key, COOKIE_CONFIG);
